import React from 'react'

interface PageLayoutProps {
  children: React.ReactNode
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col h-screen">
      <main className="flex flex-1 w-full">{children}</main>
    </div>
  )
}

export default PageLayout
